// Convierte archivo (imagen o PDF) a data URL.
// Para imágenes: comprime a max 1400px lado mayor, JPEG 75%, devuelve base64.
// Para PDF u otros: devuelve base64 sin comprimir (límite 2MB).
export async function fileToCompressedDataUrl(file, maxDim = 1400, quality = 0.75) {
  if (!file) return "";
  // PDF u otros: devolver tal cual (límite 2MB)
  if (!file.type.startsWith("image/")) {
    if (file.size > 2 * 1024 * 1024) throw new Error("Archivo > 2MB. Use imagen JPG/PNG o PDF más pequeño.");
    return await readAsDataURL(file);
  }
  // Imagen: comprimir
  const dataUrl = await readAsDataURL(file);
  const img = await loadImage(dataUrl);
  const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
  const w = Math.round(img.width * ratio);
  const h = Math.round(img.height * ratio);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  return canvas.toDataURL("image/jpeg", quality);
}

function readAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
